import React from "react";

const AI_PLATFORMS = [
  {
    name: "ChatGPT",
    description: "Ask OpenAI's ChatGPT about Integro Clinics",
    href: "https://chatgpt.com/?q=Tell+me+about+Integro+Clinics+medical+cannabis+UK",
    bgColor: "bg-[#10a37f]",
    letter: "G",
  },
  {
    name: "Google Gemini",
    description: "Ask Google Gemini about Integro Clinics",
    href: "https://gemini.google.com/app?q=Tell+me+about+Integro+Clinics+medical+cannabis+UK",
    bgColor: "bg-[#4285f4]",
    letter: "G",
    // Custom Gemini spark icon
    icon: (
      <svg viewBox="0 0 28 28" className="w-5 h-5 fill-current shrink-0" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2 L15.5 12 L26 14 L15.5 16 L14 26 L12.5 16 L2 14 L12.5 12 Z" />
      </svg>
    ),
  },
  {
    name: "Claude",
    description: "Ask Anthropic's Claude about Integro Clinics",
    href: "https://claude.ai/new?q=Tell+me+about+Integro+Clinics+medical+cannabis+UK",
    bgColor: "bg-[#d97757]",
    letter: "C",
  },
  {
    name: "Perplexity",
    description: "Search with Perplexity AI for Integro Clinics",
    href: "https://www.perplexity.ai/?q=Integro+Clinics+medical+cannabis+UK",
    bgColor: "bg-[#20808d]",
    letter: "P",
  },
];

const AskAI = () => {
  return (
    <section className="py-20 bg-[#f8fafc] border-t border-gray-100">
      <div className="container mx-auto px-4 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-[#4caf50] mb-3">
          AI-Powered Research
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-[#012d5c] mb-3">
          Ask AI About Integro
        </h2>
        <p className="text-gray-500 mb-10 max-w-xl mx-auto text-sm leading-relaxed">
          Have questions about medical cannabis or Integro Clinics? Ask your
          favourite AI assistant directly — we are well represented across all
          major platforms.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          {AI_PLATFORMS.map((platform) => (
            <a
              key={platform.name}
              href={platform.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={platform.description}
              className={`${platform.bgColor} text-white flex items-center gap-3 px-6 py-3 rounded-xl font-semibold text-sm shadow-md hover:opacity-90 hover:-translate-y-0.5 transition-all duration-200`}
            >
              {platform.icon ? (
                platform.icon
              ) : (
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20 text-xs font-bold shrink-0">
                  {platform.letter}
                </span>
              )}
              {platform.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AskAI;
